<template>
  <div class="field-container">
    <div v-if="field.id" id="fieldName" class="d-flex align-center fs-exclude pa-4 elevation-2 mb-2">
      <v-icon :class="field.completed ? 'primary--text' : 'text--disabled'" class="mr-4">
        check_circle
      </v-icon>
      <div id="translate-field-step-3">
        <p class="ma-0 body-1 font-weight-bold" style="line-height: 1.2">
          {{ field.field }}
        </p>
        <p v-if="field.original" class="ma-0 body-2" style="font-size: 12px !important; line-height: 1">
          {{ field.original }}
        </p>
      </div>
      <v-spacer />
      <v-btn id="select-field-step-4" color="tertiary" text :disabled="field.completed" @click="$emit('skip')">
        Skip
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    field: { type: Object, required: true }
  },
  watch: {
    field: {
      handler(val, oldVal) {
        const element = document.getElementById('fieldName')
        if (element) {
          if (val.order < oldVal.order) {
            element.animate([{ left: `-${window.innerWidth}px`, easing: 'ease-out' }, { left: 0 }], { duration: 300 })
          } else {
            element.animate([{ left: `${window.innerWidth}px`, easing: 'ease-out' }, { left: 0 }], { duration: 300 })
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.field-container {
  position: relative;
  overflow: hidden;
  height: 82px;
}

#fieldName {
  position: absolute;
  left: 0;
  width: 100%;
}
</style>
